/**
 * Breadcrumbs Composable
 *
 * Generates breadcrumb items from current route
 */
import { computed, type Component } from 'vue';
import { useRoute } from 'vue-router';

export interface BreadcrumbItem {
  label: string;
  to?: string;
  icon?: Component;
}

export function useBreadcrumbs() {
  const route = useRoute();

  const breadcrumbs = computed<BreadcrumbItem[]>(() => {
    const items: BreadcrumbItem[] = [];

    // Always add home
    items.push({
      label: 'Home',
      to: '/',
    });

    // Get breadcrumb from route meta or generate from path
    if (route.meta.breadcrumbs) {
      items.push(...(route.meta.breadcrumbs as BreadcrumbItem[]));
    } else {
      // Auto-generate from path
      const pathSegments = route.path.split('/').filter(Boolean);

      pathSegments.forEach((segment, index) => {
        const path = '/' + pathSegments.slice(0, index + 1).join('/');
        const isLast = index === pathSegments.length - 1;
        const label = isLast && route.meta.title
          ? (route.meta.title as string)
          : segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');

        items.push({
          label,
          to: path,
        });
      });
    }

    // Remove last item's link (current page)
    if (items.length > 0) {
      delete items[items.length - 1].to;
    }

    return items;
  });

  return {
    breadcrumbs,
  };
}
